import { Id } from 'Common/Id';
import { PublicRole } from 'Common/permissions/PublicRole';
import {Roles} from 'Common/permissions/Roles';
import {RolesLoader} from 'Common/permissions/RolesLoader';

export class User 
{
	static readonly unknownKey = 'eeeeeeeeeeeeeeeeeeeeeeee';

	constructor(
		readonly id: Id, 
		readonly firstName:string,
		readonly lastName:string,
		readonly email:string,
		readonly roles: Roles
	)
	{ }

	toJson():any
	{
		/* Note that the session stores a JSON object - converting Id and Roles to JSON */

		return {
			id: this.id,
			firstName: this.firstName,
			lastName: this.lastName,
			email: this.email,
			roles: this.roles.toJson()
		};
	}

	/* The id argument should be supplied in the server, where ObjectId is available. */
	public static fromJson(json:any):User
	{
		return new User(json.id,json.firstName,json.lastName,json.email,
			(new RolesLoader()).createRoles(json.roles)
		);
	}

	isUnknown():boolean
	{
		return this.id == User.unknownKey;
	}

	static unknownUser():User
	{
		return new User(User.unknownKey,'','','',new Roles([new PublicRole()]));
	}
}

